import React, { Component } from "react";
import { Select } from "@blueprintjs/select";
import { MenuItem, Icon, Position } from "@blueprintjs/core";

// dacă folosești TypeScript, poți păstra ofType<T>(); în JS e ok direct:
const UISelect = Select;

class CustomSelect extends Component {
  // renderer implicit pentru item
  renderItem = (item, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) return null;
    return (
      <MenuItem
        key={item.id ?? item.value ?? item.name}
        text={item.name}
        active={modifiers.active}
        onClick={handleClick}
        icon={item?.icon}
        roleStructure="listoption"
      />
    );
  };

  // predicate implicit pentru search (căutare în mai multe chei)
  itemPredicate = (query, item) => {
    if (!query) return true;
    const q = query.toLowerCase();
    const { searchKeys = ["name", "code", "label"] } = this.props;

    return searchKeys.some((k) => {
      const v = (item?.[k] ?? "").toString().toLowerCase();
      return v.includes(q);
    });
  };


  render() {
    var popoverProps = this.props.popoverProps || { minimal: true, usePortal: false, position: Position.TOP_LEFT }

    const {
      items = [],
      selectedItem,
      onItemSelect,
      itemRenderer,
      itemPredicate,
      placeholder = "Selectează...",
      searchPlaceholder = "Caută...",
      noResultsText = "Nu s-au găsit rezultate",
      filterable = true, // activăm căutarea by default
    } = this.props;
    console.log('PROPS', this.props)
    return (
      <UISelect
        items={items}
        itemRenderer={itemRenderer || this.renderItem}
        itemPredicate={itemPredicate || this.itemPredicate
        }
        onItemSelect={onItemSelect}
        filterable={filterable}
        inputProps={{ placeholder: searchPlaceholder, "aria-label": "Căutare", className: 'search-input' }}
        noResults={< MenuItem disabled text={noResultsText} roleStructure="listoption" />}
        className={`uiselect-fm ${this.props.className || ""}`}
        // popoverProps={}
        popoverProps={popoverProps}
        resetOnClose
      >
        {
          this.props.button ? (
            this.props.button
          ) : (
            <button className="fm-select" type="button">
              {selectedItem?.name && selectedItem?.icon ? (
                <>
                  <Icon size={24} icon={selectedItem.icon} />
                  <span className="flex-1">{selectedItem?.name}</span>
                </>
              ) : (
                selectedItem?.name || placeholder
              )}
              <span className="bp5-icon bp5-icon-caret-down" />
            </button>
          )
        }
      </UISelect >
    );
  }
}

export default CustomSelect;
